import {PagewebUrlMatcher} from './PagewebUrlMatcher.class';

export const pagewebUrlMatcher = new PagewebUrlMatcher();
